<template>
    <div class="app-main">
		<el-row type="flex" class="app-main-header" align="middle">
            <el-col :span="6">
				<div class="router-title">
					<i class="el-icon-s-home"></i><span style="margin-left: 5px;">{{$route.meta.title}}</span>
				</div>
			</el-col>
            <el-col :span="18" class="app-main-header-btns">
				<el-button size="small" type="primary" @click="handleAdd">新增 </el-button>
				<el-button size="small" type="primary" @click="handleBatchDel" :disabled="ids.length<1">批量删除 </el-button>
			</el-col>
		</el-row>
        <el-row class="mg-b5">
            <el-card class="box-card">
                <div slot="header" class="clearfix">
                    <el-form :inline="true" class="demo-form-inline">
						<el-form-item class="my-form-item">
							<el-select size="mini" clearable v-model="quertInfo.objMap.status" style="width:100px"
								placeholder="选择状态">
								<el-option label="启用" value="1"></el-option>
								<el-option label="禁用" value="0"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item class="my-form-item">
							<el-input size="mini" placeholder="请输入查询条件" clearable v-model="quertInfo.objMap.search"
								style="width: 160px" prefix-icon="el-icon-search"></el-input>
						</el-form-item>
						<el-form-item class="my-form-item">
							<el-button size="mini" type="primary" @click="onSearch"
								v-hasPermi="['basic:basicCurrency:query']">查询
							</el-button>
						</el-form-item>
					</el-form>
                </div>
                <el-table :data="tableData" border size="mini" :header-cell-style="headerCellStyle" @selection-change="handleSelectionChange" :height="tableHeight()">
					<el-table-column type="selection" width="40" align="left"> </el-table-column>
					<el-table-column prop="name" label="运费模式" :show-overflow-tooltip="true">
						<template slot-scope="scope">
							<el-link type="primary" @click="form=scope.row;drawer = true">
								{{scope.row.name}}
							</el-link>
						</template>
					</el-table-column>
					<el-table-column prop="code" label="编码" :show-overflow-tooltip="true"></el-table-column>
					<el-table-column prop="status" label="状态" :formatter="formatStatus"></el-table-column>
					<el-table-column prop="createTime" label="创建时间" :show-overflow-tooltip="true"> </el-table-column>
					<!-- <el-table-column label="创建人" prop="createUser"> </el-table-column> -->
					<el-table-column label="操作" width="90" align="left">
						<template slot-scope="scope">
							<el-button type="text" size="small" @click="handleEdit(scope.row)"
								v-hasPermi="['basic:basicCurrency:edit']">修改
							</el-button>
							<el-button type="text" size="small" @click="handleDel(scope.row.id)"
								v-hasPermi="['basic:basicCurrency:del']">删除
							</el-button>
						</template>
					</el-table-column>
				</el-table>
				<el-row type="flex" justify="end" class="mg-t5">
					<pagination v-show="count>0" @on-pagination="onPagination" :page.sync="quertInfo.page"
						:limit.sync="quertInfo.limit" :total="count">
					</pagination>
				</el-row>
            </el-card>
        </el-row>
        <el-dialog :visible.sync="openDialog" width="600px" :title="title" :close-on-click-modal="false">
			<el-form label-width="100px" ref="form" :model="form" :rules="rules" size="small">
				<el-row>
					<el-col :span="24">
						<el-form-item label="名称" prop="name">
							<el-input v-model="form.name" placeholder="请输入制造商名称" />
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item label="编码" prop="code">
							<el-input v-model="form.code" placeholder="请输入制造商编码" />
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item label="状态" prop="status">
							<el-radio-group v-model="form.status">
								<el-radio :label="1">启用</el-radio>
								<el-radio :label="0">停用</el-radio>
							</el-radio-group>
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="openDialog = false" size="small">取 消</el-button>
				<el-button type="primary" @click="submitForm" size="small">确 定</el-button>
			</span>
		</el-dialog>
    </div>
</template>
<script>
    import {
		basicMakerList,basicMakeradd,basicMakeredit,basicMakerdel,basicMakerbatchDel,getProductAllList
	} from '@/api/basic/basicMaker.js'
    export default {
        name: "BasicMaker",
		computed: {},
		data() {
            return {
                title: "",
                tableData: [],
                ids:[],
                form: {},
                openDialog: false,
                count: 0,
				quertInfo: {
					page: 1, //当前页码
					limit: 20, //当前每页显示的数量
					objMap: {
						search: ''
					}
                },
                rules: {
					name: [{ required: true, message: '请输入货币种类', trigger: 'blur' }],
					code: [{ required: true, message: '请输入编码', trigger: 'blur' }],
				}
            }
        },
        created(){
            this.getList();
        },
        methods:{
            // 更新store数据
			async getMakerInfo(){
				let _this = this;
				const { data: res } = await getProductAllList({})
				if (res.code == 0) {
					let list = res.data||[];
					let listObj = {};
					list.forEach((item)=>{
						listObj[`${item.code}`] = item.name;
					});
					this.$store.dispatch('app/setMakerInfo', {list:list,obj:listObj})
				}
			},
            onPagination: function(val) {
				this.quertInfo.page = val.page;
				this.quertInfo.limit = val.limit;
				this.getList();
			},
            async getList(){
                let _this = this;
				const {
					data: res
				} = await basicMakerList(_this.quertInfo)
				if (res.code == 0) {
					_this.tableData = res.data;
					_this.count = res.count;
				}
            },
            handleSelectionChange(val) {
				this.ids = [];
				for (let item of val) {
					this.ids.push(item.id);
				}
			},
            onSearch: function() {
				//重置页码（会出现查询搜索字段在当前页码之前，会查询不到）
				this.quertInfo.page = 1;
				this.getList();
			},
            handleAdd: function() {
				this.reset();
				this.title = "新增";
				this.openDialog = true;
            },
            handleEdit: function(row) {
				this.reset();
				this.title = "修改";
				this.form = JSON.parse(JSON.stringify(row)); //直接赋值 表格数据 也会改变 要深拷贝复制
				this.openDialog = true;
			},
            // 表单重置
			reset: function() {
				this.form = {
					id: undefined,
					name: undefined,
					code: undefined,
					status: 1,
					createUser: this.$store.getters['user/user'].id,
				}
				if (this.$refs["form"] !== undefined) {
					this.$refs["form"].resetFields();
				}
            },
            handleBatchDel: function() {
				//批量删除
				let _this = this;
				if (_this.ids.length <= 0) {
					_this.$fail("请勾选要删除的行数据");
					return false;
				}
				_this.confirm({
					text: '确认删除吗',
					tip: '警告',
					type: '',
					fn: function(param) {
						basicMakerbatchDel(param).then(response => {
							if (response.data.code === 0) {
								_this.$success(response.data.msg);
                                _this.getList();
                                _this.getMakerInfo();
							} else {
								_this.$fail(response.data.msg);
							}
						});
					},
					data: {
						ids: _this.ids
					} //参数对象 主要回调函数用
				});
			},
            handleDel: function(id) {
				let _this = this;
				_this.confirm({
					text: '确认删除吗',
					tip: '警告',
					type: '',
					fn: function(param) {
						basicMakerdel(param).then(response => {
							if (response.data.code === 0) {
								_this.$success(response.data.msg);
                                _this.getList();
                                _this.getMakerInfo();
							} else {
								_this.$fail(response.data.msg);
							}
						});
					},
					data: {
						id: id
					} //参数对象 主要回调函数用
				});
			},
            formatStatus: function(row) {
				return row.status == 1 ? '启用' : '禁用';
            },
            submitForm() {
				let _this = this;
				_this.$refs['form'].validate((valid) => {
					if (valid) {
                        console.log(_this.form)
						if (_this.form.id != undefined) {
							basicMakeredit(_this.form).then(response => {
								if (response.data.code === 0) {
									_this.$success(response.data.msg);
									_this.openDialog = false;
                                    _this.getList();
                                    _this.getMakerInfo();
								} else {
									_this.$fail(response.data.msg);
								}
							});
						} else {
                            let curForm = {..._this.form}
                            delete curForm.id
							basicMakeradd(curForm).then(response => {
								if (response.data.code === 0) {
									_this.$success(response.data.msg);
                                    _this.openDialog = false;
                                    this.quertInfo.page = 1;
                                    _this.getList();
                                    _this.getMakerInfo();
								} else {
									_this.$fail(response.data.msg);
								}
							});
						}
					}
				});
			},
        },
    }
</script>
